
import { Vue, Component, Watch } from 'vue-property-decorator';

@Component
export default class Rule extends Vue {
  async created() {}
}
